import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
//import { Modal, ModalHeader, ModalBody } from 'reactstrap';
//import Swiper from 'react-id-swiper';
import axios from 'axios';
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 
// import Cookies from 'universal-cookie';

import ls from "local-storage"; 
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
const favimg=require('../../assets/img/favicon.png');
var QRCode = require('qrcode.react');

class QRcode extends Component { 
    
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
     
       
        this.state = {
            wallet_amount:"",
           api_url:localStorage.getItem('api_url'),
             showNav3: false,user_details:'',
             currency_code:"",
          customer_id:"",

        }
       
        
    }
      addDefaultSrc(ev){
          ev.target.src =  require('../../assets/img/howzu-logo-default.png')
        }


    componentDidMount(){
      
        var datalist = new FormData();   
      datalist.set('user_id', JSON.parse(localStorage.getItem('session_userid'))); 
      datalist.set('language', this.state.langKey); 
      
      axios({
        method: 'post',
        url: this.state.api_url+'webprofile',
        data: datalist,    
        config: { headers: {'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin' : '*',
            'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
         }}
          }).then(res => {
                     
            if(res.data.status === 'true') {
                 
                 console.log(res.data.result);
                  this.setState({
                   wallet_amount:res.data.result.wallet_amount,
                    customer_id:res.data.result.customer_id,
                    //currency_code:res.data.result.currency_code,
                    currency_code:res.data.result.currency,
                });
                  document.getElementById('wallet_val').value=this.state.wallet_amount;
                  console.log("currency_code="+this.state.currency_code);

                //   localStorage.setItem('wallet_amount',this.state.wallet_amount); 

                  
                
                
            } else {
                this.props.history.push("/login");   
            }

            
    }).catch(error => {
       this.props.history.push("/login"); 
    });
      
    
      }

     
   
    
    render() {
      const { t } = this.props;  
        const params = {
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          spaceBetween: 1,
          rebuildOnUpdate: true   
        }  

        const params2 = {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },  
            slidesPerView: 3,
            slidesPerColumn: 1,
            breakpoints: {
                360: {
                    slidesPerView: 3,
                },
                359: {
                    slidesPerView: 2,
                }
            }
        };

  const downloadQRCode = () => {
    // var testqr = document.getElementById('qrCodeEl');
    // if(testqr){
    //   //testqr.crossOrigin="anonymous"
    //     var dataurl = testqr.toDataURL("image/jpeg")
    //     console.log(dataurl)
    //     if(dataurl){
    //         var qrCodeURL = dataurl.replace("image/png", "image/octet-stream");
    //         console.log(qrCodeURL)
    
    //     }
    // }
    //return false   
    // var x = document.getElementsByClassName("ProfileSpace");
    // console.log(x[0].getElementsByTagName('img'));
    // var elements = x[0].getElementsByTagName('img')
    // while (elements[0]) elements[0].parentNode.removeChild(elements[0])
    // setTimeout(function(){
//       var canvas = document.getElementById("qrCodeEl").getContext("2d");


// var image = new Image();
// image.crossOrigin = "anonymous";  // This enables CORS

//         canvas.drawImage(image, 0, 0, 200, 200);
        
//         let aEl = document.createElement("a");
//       aEl.href = canvas.canvas.toDataURL();;
//       aEl.download = "wallet-QRcode.png";
//       document.body.appendChild(aEl);
//       aEl.click();
//       document.body.removeChild(aEl);
//         alert(1);
   
// return

      const qrCodeURL = document.getElementById('qrCodeEl').toDataURL("image/png").replace("image/png", "image/octet-stream");
      let aEl = document.createElement("a");
      aEl.href = qrCodeURL;
      aEl.download = "wallet-QRcode.png";
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);

    //}, 2000);   
   
  }

        return (

            <div className="setting-page">

               <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
                    <div className="heading-left-top d-flex">
                        <div className="align-self-center ">
                            <div className="iconHolder align-self-center mr-1">
                                <div className="backGlow  d-block d-lg-none">
                                    <div className="sideBarToggler sidebarIcoPos" onClick={() => this.setState({ showNav3: true })}></div>
                                </div>
                            </div>
                        </div>
                        <span className="arrow-center align-self-center ml-1 bold-font"><Trans i18nKey="QR code">QR code</Trans></span> 
                    </div>
                    <div className="backGlow white-bg"></div>
                     
                    
                </div> 
               

                <div className="settingsPageWidth">
                
                    <div className="setFiltBox1">
                        <div className="ProfileSpace" style={{"textAlign":"center"}}>
                        {this.state.customer_id==""?
                          "":
                            <React.Fragment>
                            <QRCode 
                            value={this.state.customer_id}
                            level="H" 
                            id="qrCodeEl"
                            bgColor="#FFFFFF"
                            size={250}
                            includeMargin={true}
                    			   imageSettings={{
                    			    src: favimg,
                    			    x: null,
                    			    y: null,
                    			    height: 24,
                    			    width: 24,
                    			    excavate: true,
                    			  }}	
                            />
                            <input
                            type="button"
                            className="btn-common add_wallet_btn"
                            value={t('Download QR code')} 
                            onClick={downloadQRCode}
                          />
                          </React.Fragment>
                       }
                           

                        </div>

   
                    </div>

                </div>


                  <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() => this.setState({ showNav3: false })} title={<div></div>} items={[<SideBar />]} />
                </div>





               





            </div>
        )
    }
}

export default withTranslation("translations")(QRcode);
